import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import PageHeader from '../../UI/PageHeader';
import Toggle from '../../UI/Toggle';
import { URL_CONFIG } from '../../constants/rest-config';
import { httpHandler } from '../../http/http-interceptor';
import ToggleSidebar from '../../layout/Sidebar/ToggleSidebar';
import ConfirmStateModal from '../../modals/ConfirmStateModal';
import EEPSubmitModal from '../../modals/EEPSubmitModal';
import { BreadCrumbActions } from '../../store/breadcrumb-slice';
import html2pdf from 'html2pdf.js';
import { pageLoaderHandler } from '../../helpers';
import Chart from 'react-apexcharts';
import SurveyCharts from '../Charts/SurveyCharts';
import SurveyResponses from './SurveyResponses';
import PulseSruveyResponse from './PulseSruveyResponse';
import Isloading from '../../UI/CustomComponents/Isloading';

const Pulse = () => {
  const svgIcons = useSelector((state) => state.sharedData.svgIcons);

  const [toggleSwitch, setToggleSwitch] = useState(false);
  const [surveyPulseResponseData, setSurveyPulseResponseData] = useState([]);
  const [pulseResponseData, setPulseResponseData] = useState({});

  const location = useLocation();
  const sDataValue = location.state ? location.state?.surveyData : null;
  const [isloadingPdf, setIsPdfloading] = useState(false);
  const [surveyResponseStateData, setSurveyResponseStateData] =
    useState(sDataValue);
  const [showModal, setShowModal] = useState({ type: null, message: null });
  const [confirmStateModalObj, setConfirmStateModalObj] = useState({
    confirmTitle: null,
    confirmMessage: null,
  });
  const [allExpended, setAllExpended] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const hideModal = () => {
    let collections = document.getElementsByClassName('modal-backdrop');
    for (var i = 0; i < collections.length; i++) {
      collections[i].remove();
    }
    setShowModal({ type: null, message: null });
  };
  const dispatch = useDispatch();

  const breadcrumbArr = [
    {
      label: 'Home',
      link: 'app/dashboard',
    },
    {
      label: 'Engage',
      link: 'app/engage',
    },
    {
      label: 'Survey',
      link: 'app/mysurvey',
    },
    {
      label: 'Survey Responses',
      link: '',
    },
  ];

  useEffect(() => {
    dispatch(
      BreadCrumbActions.updateBreadCrumb({
        breadcrumbArr,
        title: 'Survey Results',
      })
    );
    return () => {
      BreadCrumbActions.updateBreadCrumb({
        breadcrumbArr: [],
        title: '',
      });
    };
  }, []);

  const fetchSurveyPulseResponses = (surData) => {
    setIsLoading(true);

    if (surData && Object.keys(surData).length) {
      const obj = {
        url: URL_CONFIG.SURVEY_PULSE_RESPONSE,
        method: 'get',
        params: { id: surData?.id },
      };
      httpHandler(obj)
        .then((response) => {
          setPulseResponseData(response?.data);
          setSurveyPulseResponseData(
            response?.data.averageScorePerQuestion
              ? response?.data.averageScorePerQuestion
              : []
          );
          setIsLoading(false);
        })
        .catch((error) => {
          setShowModal({
            ...showModal,
            type: 'danger',
            message: error?.response?.data?.message,
          });
          setIsLoading(false);
        });
    }
  };
  useEffect(() => {
    fetchSurveyPulseResponses(surveyResponseStateData);

    pageLoaderHandler(isLoading ? 'show' : 'hide');
  }, [surveyResponseStateData]);

  const modalState = (item) => {
    setToggleSwitch(true);
    setConfirmStateModalObj({
      confirmTitle: 'Confirm Action',
      confirmMessage: item
        ? 'Do you want to Pause accepting new responses? '
        : 'Do you want to Start accepting new responses?',
    });
  };

  const confirmState = (arg) => {
    if (arg) {
      const obj = {
        url:
          URL_CONFIG.SURVEY_ACCEPT_RESPONSE +
          '?id=' +
          surveyResponseStateData.id +
          '&response=' +
          (surveyResponseStateData.acceptResponse ? '0' : '1'),
        method: 'put',
      };
      httpHandler(obj)
        .then(() => {
          setShowModal({
            ...showModal,
            type: 'success',
            sucess: surveyResponseStateData.acceptResponse
              ? 'Action Successful!'
              : 'Success!',
            message: surveyResponseStateData.acceptResponse
              ? 'Survey closed for further responses.'
              : 'Survey reopened for responses.',
          });
          let surveyResponseStateDataTemp = JSON.parse(
            JSON.stringify(surveyResponseStateData)
          );
          if (surveyResponseStateData.acceptResponse) {
            surveyResponseStateDataTemp['acceptResponse'] = false;
            setSurveyResponseStateData({ ...surveyResponseStateDataTemp });
          } else {
            surveyResponseStateDataTemp['acceptResponse'] = true;
            setSurveyResponseStateData({ ...surveyResponseStateDataTemp });
          }
        })
        .catch((error) => {
          const errMsg =
            error.response?.data?.message !== undefined
              ? error.response?.data?.message
              : 'Something went wrong contact administarator';
          setShowModal({
            ...showModal,
            type: 'danger',
            message: errMsg,
          });
        });
      setToggleSwitch(false);
    } else {
      setToggleSwitch(false);
    }
  };

  function convertHtmlToPdf() {
    const element = document.getElementById('screen');
    const options = {
      margin: 1,
      filename: 'surveyresponse.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 1.5, scrollX: 0, scrollY: -window.scrollY },
      jsPDF: { unit: 'mm', format: 'a2', orientation: 'portrait', width: 1020 },
      pagebreak: { mode: 'avoid-all' },
    };
    setTimeout(() => {
      html2pdf().set(options).from(element).save();
      setAllExpended(false);
      setIsPdfloading(false);
    }, 800);
  }
  const onClickDownload = async (element) => {
    setIsPdfloading(true);
    convertHtmlToPdf();
  };

  // Check that surveyPulseResponseData is an array and map only if it contains data
  const questions = Array.isArray(surveyPulseResponseData)
    ? surveyPulseResponseData.map((data) => data.question || 'N/A')
    : [];

  const averageScores = Array.isArray(surveyPulseResponseData)
    ? surveyPulseResponseData.map((data) => data.average_score || 0)
    : [];

  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    legend: {
      show: false, // Set this to false to hide the legend
    },
    xaxis: {
      categories: questions,
      labels: {
        style: {
          fontSize: '10px', // Reduce font size for readability
        },
      },
    },
    plotOptions: {
      bar: {
        barHeight: '50%', // Adjust bar height for better spacing
        distributed: true,
        horizontal: true,
        dataLabels: {
          position: 'bottom',
        },
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels to avoid clutter
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    yaxis: {
      labels: {
        show: true,
        maxWidth: 200, // Limit width to prevent long labels from overlapping
      },
      title: {
        text: undefined,
      },
    },
    title: {
      text: 'Survey Questions and Average Scores',
      align: 'center',
      style: {
        fontSize: '16px',
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value) => `Average Score: ${value}`,
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 300,
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '8px',
              },
            },
          },
        },
      },
    ],
  };

  const series = [
    {
      name: 'Average Score',
      // data: [10,20,30,40,50,60,70,80,90,100,66,75,44,33,22,11,77,54,12,88],
      data: averageScores,
    },
  ];
  const validResponses = surveyPulseResponseData?.filter((item) => {
    const score = Number(item?.average_score);
    return !isNaN(score);
  });

  const totalScore = validResponses?.reduce(
    (acc, item) => acc + Number(item.average_score),
    0
  );
  const overallScore = totalScore / surveyPulseResponseData.length;

  const allResponses = surveyPulseResponseData
    .flatMap((item) => item.responses)
    .filter((value) => value !== null && value !== 0);
  const highestNumber =
    allResponses.length > 0 ? Math.max(...allResponses) : null;

  const overallScorePercentage = (overallScore / highestNumber) * 100; // Assuming max score is 5
  const semiOptions = {
    chart: {
      type: 'radialBar',
      // height: 100, // or any other suitable number
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: '#e7e7e7',
          strokeWidth: '97%',
          margin: 5, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            color: '#999',
            opacity: 1,
            blur: 2,
          },
        },
        dataLabels: {
          name: {
            fontSize: '12px',
          },
          // value: {
          //   fontSize: '14px',
          //   formatter: function () {
          //     return `${overallScore.toFixed(2)} / 5`;
          //   },
          // },
          total: {
            show: true,
            fontSize: '10px',
            margin: '0',
            label: `Net Positivity ${
              overallScorePercentage ? overallScorePercentage.toFixed(0) : 0
            }%`,
            formatter: function () {
              return ``;
            },
          },
        },
      },
    },
    // series: [`${overallScorePercentage.toFixed(1)}%`],
    // labels: ['Overall Score'],
  };

  const totOptions = {
    chart: {
      height: 350,
      type: 'radialBar',
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 0,
          size: '70%',
          background: '#fff',
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: 'front',
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24,
          },
        },
        track: {
          background: '#fff',
          strokeWidth: '67%',
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35,
          },
        },

        dataLabels: {
          show: true,
          name: {
            offsetY: -10,
            show: true,
            color: '#888',
            fontSize: '12px',
          },
          value: {
            formatter: function (val) {
              return `${parseInt(Number(val) ? val : 0)}%`;
            },
            color: '#111',
            fontSize: '24px',
            show: true,
          },
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: ['#ABE5A1'],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    stroke: {
      lineCap: 'round',
    },
    labels: ['Response'],
  };

  const totSeries = [
    (pulseResponseData?.answerCount / pulseResponseData?.assignCount) * 100,
  ];
  // Response chart END

  return (
    <React.Fragment>
      {!isLoading && (
        <>
          {isloadingPdf && (
            <div
              id="page-loader-container"
              style={{ zIndex: '1051' }}
            >
              <div id="loader">
                <img
                  src={process.env.PUBLIC_URL + '/images/loader.gif'}
                  alt="Loader"
                />
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    paddingTop: '10px',
                    color: '#000',
                  }}
                >
                  Downloading Pdf...
                </div>
              </div>
            </div>
          )}
          {showModal.type !== null && showModal.message !== null && (
            <EEPSubmitModal
              data={showModal}
              className={`modal-addmessage`}
              hideModal={hideModal}
              successFooterData={
                <button
                  type="button"
                  className="eep-btn eep-btn-xsml eep-btn-success"
                  data-dismiss="modal"
                  onClick={hideModal}
                >
                  Got It
                </button>
              }
              errorFooterData={
                <button
                  type="button"
                  className="eep-btn eep-btn-xsml eep-btn-danger"
                  data-dismiss="modal"
                  onClick={hideModal}
                >
                  Close
                </button>
              }
            ></EEPSubmitModal>
          )}

          {toggleSwitch && (
            <ConfirmStateModal
              hideModal={hideModal}
              confirmState={confirmState}
              confirmTitle={confirmStateModalObj.confirmTitle}
              confirmMessage={confirmStateModalObj.confirmMessage}
            />
          )}

          <PageHeader
            title="Survey Results"
            navLinksLeft={
              <Link
                to="/app/survey"
                className="text-right c-c1c1c1 ml-2 my-auto eep_nav_icon_div eep_action_svg"
                dangerouslySetInnerHTML={{
                  __html: svgIcons && svgIcons.lessthan_circle,
                }}
              ></Link>
            }
            toggle={
              <Toggle
                modalState={modalState}
                checkState={surveyResponseStateData?.acceptResponse}
              />
            }
            download={
              <button
                onClick={onClickDownload}
                className="btn btn-secondary"
                aria-controls="user_dataTable"
                type="button"
                style={{ marginRight: '8px', borderRadius: '6px' }}
              >
                Download Report
              </button>
            }
          />
          {isLoading ? (
            <Isloading />
          ) : (
            <div className="row eep_dashboard_div">
              <div className="col-sm-12 col-xs-12 col-md-8 col-lg-5 position_sticky eep-content-section eep-content-section-max">
                <div className="br-15 h-100 divFullHeight">
                  <div className="row px-0 mb-3">
                    <div className="col-md-6 ">
                      <div className="bg-white br-10   h-100 border border-1 ml-12">
                        <Chart
                          options={semiOptions}
                          series={[overallScorePercentage]}
                          type="radialBar"
                          height={300}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="bg-white br-10   h-100 border border-1 ml-12">
                        <Chart
                          options={totOptions}
                          series={[totSeries]}
                          type="radialBar"
                          height={300}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row px-0 mb-3 h-100">
                    <div className="col-md-12">
                      <div className="bg-white br-10 h-100 border border-1">
                        <Chart
                          options={options}
                          series={series}
                          type="bar"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-xs-12 col-md-4 col-lg-7 eep-content-section eep-content-section-max eep_scroll_y">
                <PulseSruveyResponse
                  header={false}
                  pulseResponseData={pulseResponseData}
                />
              </div>
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default Pulse;
